const multipleSaleText = {
  'multipleSaleText.withMultipleSale':
    '每次最少购买 {minSaleCount} 件，且购买数量必须为 {multipleSaleCount} 的倍数',
  'multipleSaleText.withoutMultipleSale': '每次最少购买 {minSaleCount} 件',
  'multipleSaleText.withoutMinSaleCount': '购买数量必须为 {multipleSaleCount} 的倍数',
};

export default multipleSaleText;
